import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Search } from 'lucide-react';
import { NameData } from '../types';
import { loadNameData } from '../utils/name';
import AlphabetFilter from './AlphabetFilter';
import GenderFilter from './GenderFilter';
import PopularNames from './PopularNames';
import NameDisplay from './NameDisplay';

export default function NameSearch() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedGender, setSelectedGender] = useState<'boys' | 'girls' | null>(null);
  const [selectedLetter, setSelectedLetter] = useState<string | null>(null);
  const [names, setNames] = useState<NameData[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function loadNames() {
      if (selectedGender && selectedLetter) {
        setLoading(true);
        try {
          const data = await loadNameData(selectedGender, selectedLetter);
          setNames(data);
        } catch (error) {
          console.error('Error loading names:', error);
          setNames([]);
        }
        setLoading(false);
      }
    }
    loadNames();
  }, [selectedGender, selectedLetter]);

  const filteredNames = names.filter(name =>
    name.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleNameClick = (name: string) => {
    setSearchTerm(name);
  };

  return (
    <div className="max-w-4xl mx-auto">
      <div className="mb-8">
        <div className="relative">
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search names..."
            className="w-full px-4 py-3 pl-12 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
          <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
        </div>
      </div>

      <GenderFilter
        selectedGender={selectedGender}
        onGenderSelect={setSelectedGender}
      />

      <AlphabetFilter
        selectedLetter={selectedLetter}
        onLetterSelect={setSelectedLetter}
        gender={selectedGender}
      />

      {loading ? (
        <div className="flex justify-center py-12">
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
            className="w-8 h-8 border-2 border-purple-600 border-t-transparent rounded-full"
          />
        </div>
      ) : (
        <>
  {filteredNames.length > 0 ? (
    <PopularNames names={filteredNames} onNameClick={handleNameClick} />
  ) : (
    <div className="text-center py-12 text-gray-600">
      No names found. Try other filters or search terms, or <a href="http://abh.com.np/contact" className="text-blue-500 hover:underline">suggest a name on the suggestion page</a>.
    </div>
  )}
</>

      )}
    </div>
  );
}